module.exports = __webpack_public_path__ + "img/03.98df3f00.png";